import '.ab{position:relative;}.ssr-plugin'
import '.ld{width:64px;}.ssr-plugin'
import '.le{height:64px;}.ssr-plugin'
import '.aq{flex-shrink:0;}.ssr-plugin'
import '.bx{position:absolute;}.ssr-plugin'
import '.lf{bottom:-4px;}.ssr-plugin'
import '.k2{right:-4px;}.ssr-plugin'
import '.gr{border-radius:50%;}.ssr-plugin'
import '.ch{border:2px solid var(--palette-white);}.ssr-plugin'
import '.b5{overflow:hidden;}.ssr-plugin'
import '.lg{width:32px;}.ssr-plugin'
import '.lh{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'
import { StoredImage } from '@app/types/StoredImage'

type ConversationAvatarProps = {
  initiativeImage?: StoredImage
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  const hasImage = !!initiativeImage && !!initiativeImage.src
  return (
    <div className="ab ld le aq"
    >
      {hasImage ? (
        <Image
          src={initiativeImage.src}
          alt={initiativeImage.altText || 'initiative image'}
          resizeWidth={128}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="bx lf k2 gr ch b5 lg lh"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
